const getters = {
    token: state => state.table.token, // token
    tabledata: state => state.table.tabledata,
    commlist: state => state.table.commlist,
    routerLoading: state => state.table.routerLoading, // 路由加载标识
    permissionRouters: state => state.table.routers, // 符合权限的路由
    addRouters: state => state.table.addRouters, // 根据权限获取到的路由列表
    username: state => state.table.username,
    headimgurl: state => state.table.headimgurl,
    moid: state => state.table.moid,
    lang: state => state.table.lang,
    pageSize: state => state.pagination.pageSize,
    userid: state => state.table.userid,
    oid: state => state.table.oid,
    role: state => state.table.role,
    no_role: state => state.table.no_role,
    institut: state => state.table.institut,
    authid: state => state.table.authid, // 用户权限
    replenisherStockOnly: state => state.table.replenisherStockOnly,
    organname: state => state.table.organname,
    xparentid: state => state.table.xparentid,
    lements: state => state.table.lements,
    machiname: state => state.table.machiname,
    mobile: state => state.table.mobile,
    machinesname: state => state.table.machinesname,
    jiqicode: state => state.table.jiqicode,
    create_time: state => state.table.create_time,
    nums: state => state.table.nums,
    filesUrl: state => state.table.filesUrl, 
}
export default getters
